import { render } from "./DeviceQuantityModal.vue?vue&type=template&id=671c73c8&scoped=true"
import script from "./DeviceQuantityModal.vue?vue&type=script&lang=js"
export * from "./DeviceQuantityModal.vue?vue&type=script&lang=js"

import "./DeviceQuantityModal.vue?vue&type=style&index=0&id=671c73c8&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671c73c8"]])

export default __exports__